export default "/fonts/lato-light-webfont.woff?3e5e5a4e4c71de22b7bb5e85c4bd74ec";